import { isEqual } from "./util"

import type { CompanyLocationAssociationOutput } from "@/graphql/codegen/graphql"

function allElementsSame<T>(array: T[]): boolean {
  if (array?.length === 0) return false
  const firstElement = array[0]

  const mapper =
    typeof firstElement === "object"
      ? (element: T) => isEqual(element, firstElement)
      : (element: T) => element === firstElement

  return array.every(mapper)
}

export function extractShippingViaCompanyId(associatedLocationList: CompanyLocationAssociationOutput[]): string | null {
  if (!associatedLocationList?.length) {
    return null
  }

  const ids = associatedLocationList.map(({ shippingVia }) => shippingVia?.companyId ?? null).filter(Boolean)

  return allElementsSame(ids) ? ids[0] : null
}
